import { render, staticRenderFns } from "./Ata.vue?vue&type=template&id=275c698e&"
import script from "./Ata.vue?vue&type=script&lang=js&"
export * from "./Ata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports